import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './AttachmentsDisplay.css';
import ReactPlayer from "react-player";
import { FaTimes, FaPlay, FaSpinner } from 'react-icons/fa';

const AttachmentsDisplay = ({ 
  attachments, 
  uploading, 
  editMode, 
  onRemoveAttachment 
}) => {
  if (uploading) {
    return (
      <div className="ad-uploading">
        <FaSpinner className="ad-loading-icon" />
        <span>Upload en cours...</span>
      </div>
    );
  }

  if (attachments.length === 0) return null;

  return (
    <div className="ad-container">
      {attachments.map((attachment, index) => (
        <div key={index} className="ad-attachment">
          {!editMode && (
            <div className="ad-remove" onClick={onRemoveAttachment}>
              <FaTimes />
            </div>
          )}
          
          {/* Affichage pour vidéo en traitement */}
          {attachment.fileType?.startsWith("video/") && attachment.isProcessing ? (
            <div className="ad-processing">
              <div className="ad-processing-content">
                <FaSpinner className="ad-processing-spinner" />
                <span className="ad-processing-text">Traitement de la vidéo en cours...</span>
              </div>
            </div>
          ) : 
          /* Affichage pour image */
          attachment.fileType?.startsWith("image/") ? (
            <div className="ad-image-container">
              <img 
                src={`https://peupleqc.com/s/peupleqc-upload/${attachment.filename}`}
                alt="Attachment"
                className="ad-image"
              />
            </div>
          ) : 
          /* Affichage pour vidéo traitée */
          attachment.fileType?.startsWith("video/") && !attachment.isProcessing ? (
            <div className="ad-video-container">
              <ReactPlayer
                url={`https://peupleqc.com/s/peupleqc-upload/${attachment.convertedMaster || attachment.filename}`}
                width="100%"
                height="200px"
                controls={true}
                light={attachment.mediaThumb ? `https://peupleqc.com/s/peupleqc-upload/${attachment.mediaThumb}` : true}
                playIcon={<FaPlay className="ad-play-icon" />}
              />
            </div>
          ) : 
          /* Fallback - utiliser le thumbnail s'il existe ou afficher un placeholder */
          (
            <div className="ad-image-container">
              {attachment.mediaThumb ? (
                <img 
                  src={`https://peupleqc.com/s/peupleqc-upload/${attachment.mediaThumb}`}
                  alt="Attachment"
                  className="ad-image"
                />
              ) : (
                <div className="ad-placeholder">
                  <div className="ad-placeholder-content">
                    <span className="ad-placeholder-text">
                      {attachment.filename}
                      {attachment.isProcessing && " (En traitement...)"}
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AttachmentsDisplay;
export {AttachmentsDisplay};